import React from 'react';
import SampleViewRect from './SampleViewRect.jsx';
import SampleViewRound from './SampleViewRound.jsx';
import PropTypes from 'prop-types';
import './CrystalPlate.css';

/**
 * React component which renders a plate
 */
class PlateGrid extends React.Component {
    constructor(props) {
        super(props);

        this.arePropsValid = this.arePropsValid.bind(this);
    }

    wellClick(row, col) {
        this.props.handleSelectRowSample ? this.props.handleSelectRowSample(row, col, this.props.plate.name) : null;
        this.props.handleSelectRowBuffer ? this.props.handleSelectRowBuffer(row, col, this.props.plate.name) : null;
    }

    /**
     * Props validator
     * @returns {boolean} whether the provided props are valid or not.
     */
    arePropsValid() {
        if (this.props.plate) {
            if (this.props.plate.rowTitle && this.props.plate.rowTitle instanceof Array && this.props.plate.rowTitle.length > 0) {
                if (this.props.plate.colTitle && this.props.plate.colTitle instanceof Array && this.props.plate.colTitle.length > 0) {
                    if (this.props.plate.wellSize) {
                        return this.props.plate.wellSize instanceof Array && this.props.plate.wellSize.length === this.props.plate.colTitle.length ? true : false;
                    }
                    return true;
                }
            }
        }
        return false;
    }

    render() {
        if (this.arePropsValid() === true) {
            const nbcols = this.props.plate.colTitle.length;
            const nbrows = this.props.plate.rowTitle.length;
            const plateName = this.props.plate.name;

            const fillFirstRowWithColLabels = () => {
                return this.props.plate.colTitle.map((col, index) =>
                    <div
                        className='square'
                        key={"0_" + col}
                        style={{ gridRowStart: 1, gridRowEnd: 2, gridColumnStart: index + 2, gridColumnEnd: index + 3 }}
                    >
                        <svg width="100%" height="100%" viewBox="0 0 20 20"
                            style={{ position: 'absolute' }}>
                            {col < 10 ? <text x='7' y='14' > {col} </text> : <text x='4' y='14' > {col} </text>}
                        </svg>
                    </div>);
            }

            const fillFirstColWithRowLabels = () => {
                return this.props.plate.rowTitle.map((row, index) =>
                    <div className='square'
                        key={row + '_0'}
                        style={{ gridRowStart: index + 2, gridRowEnd: index + 3, gridColumnStart: 1, gridColumnEnd: 2 }}
                    >
                        <svg width="100%" height="100%" viewBox="0 0 20 20"
                            style={{ position: 'absolute' }}>
                            <text x='6' y='13' > {row} </text>
                        </svg>
                    </div>);
            }

            const fillTopLeftCell = () => {
                return <div className='square' style={{ gridRowStart: 1, gridRowEnd: 2, gridColumnStart: 1, gridColumnEnd: 1 }} > </div>
            }

            const getPlateWells = () => {
                let plateWells = [];

                for (let row = 0; row < this.props.plate.rowTitle.length; row++) {
                    for (let col = 0; col < this.props.plate.colTitle.length; col++) {
                        let cell = null;
                        if (this.props.plate.wellShape === 'square') {
                            cell = (<div className='square' key={row + '_' + col}>
                                <svg
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                    }}

                                    onClick={() => {
                                        this.wellClick(this.props.plate.rowTitle[row], this.props.plate.colTitle[col]);
                                        this.props.handleLoadPlateRowsSample ? this.props.handleLoadPlateRowsSample(this.props.plate.rowTitle) : null;
                                        this.props.handleLoadPlateColumnsSample ? this.props.handleLoadPlateColumnsSample(this.props.plate.colTitle) : null;
                                        this.props.handlePlateAddRowDefaultValueSample ? this.props.handlePlateAddRowDefaultValueSample(plateName, row, col) : null;

                                        this.props.handleLoadPlateRowsBuffer ? this.props.handleLoadPlateRowsBuffer(this.props.plate.rowTitle) : null;
                                        this.props.handleLoadPlateColumnsBuffer ? this.props.handleLoadPlateColumnsBuffer(this.props.plate.colTitle) : null;
                                        this.props.handlePlateAddRowDefaultValueBuffer ? this.props.handlePlateAddRowDefaultValueBuffer(plateName, row, col) : null;
                                    }}
                                >
                                    <rect
                                        height='50%'
                                        width='50%'
                                        x="25%"
                                        y="25%"
                                        style={{
                                            fill: 'rgba(255, 255, 255, 0)',
                                            strokeWidth: '2',
                                            stroke: this.props.selectedWell === `${plateName}:${this.props.plate.rowTitle[row]}:${this.props.plate.colTitle[col]}` ? 'red' : 'rgb(136, 136, 136)'
                                        }} />
                                    <SampleViewRect {...this.props} platerow={this.props.plate.rowTitle[row]} platecol={this.props.plate.colTitle[col]} />
                                </svg>
                            </div>);
                        } else if (this.props.plate.wellShape === 'round') {
                            cell = (<div className='square' key={row + '_' + col} >
                                <svg
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        stroke: this.props.selectedWell === `${plateName}:${this.props.plate.rowTitle[row]}:${this.props.plate.colTitle[col]}` ? 'red' : 'rgb(136, 136, 136)'
                                    }}
                                    onClick={() => {
                                        // this.props.handleLoadPlateRowsSample(this.props.plate.rowTitle);
                                        // this.props.handleLoadPlateColumnsSample(this.props.plate.colTitle);
                                        // this.props.handlePlateAddRowDefaultValueSample(plateName, row, col);

                                        // this.props.handleLoadPlateRowsBuffer(this.props.plate.rowTitle);
                                        // this.props.handleLoadPlateColumnsBuffer(this.props.plate.colTitle);
                                        // this.props.handlePlateAddRowDefaultValueBuffer(plateName, row, col);
                                    }}
                                >
                                    <circle
                                        cx="50%"
                                        cy="50%"
                                        r="25%"
                                        strokeWidth="2"
                                        fill="rgba(253, 253, 253, 0)"
                                        onClick={() => {
                                            this.wellClick(row, col);
                                        }}
                                    />
                                    <SampleViewRound {...this.props} platerow={this.props.plate.rowTitle[row]} platecol={this.props.plate.colTitle[col]} radius={'25%'} />
                                </svg>
                            </div>);
                        } else if (this.props.plate.wellShape === 'roundBlock') {
                            let radius = this.props.plate.wellSize ? String(Math.floor(this.props.plate.wellSize[col] / 2) + '%') : '50%';
                            cell = (<div className='square' key={row + '_' + col} >
                                <svg
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        stroke: this.props.selectedWell === `${plateName}:${this.props.plate.rowTitle[row]}:${this.props.plate.colTitle[col]}` ? 'red' : 'rgb(136, 136, 136)'
                                    }}
                                    onClick={() => {
                                        //this.props.handleLoadPlateRowsSample(this.props.plate.rowTitle);
                                        //this.props.handleLoadPlateColumnsSample(this.props.plate.colTitle);
                                        //this.props.handlePlateAddRowDefaultValueSample(plateName, rowIdx, colIdx);

                                        //this.props.handleLoadPlateRowsBuffer(this.props.plate.rowTitle);
                                        //this.props.handleLoadPlateColumnsBuffer(this.props.plate.colTitle);
                                        //this.props.handlePlateAddRowDefaultValueBuffer(plateName, rowIdx, colIdx);
                                    }}
                                >
                                    <circle
                                        cx={'50%'}
                                        cy={'50%'}
                                        r={radius}
                                        strokeWidth="1"
                                        fill="rgba(253, 253, 253, 0)"
                                        onClick={() => {
                                            this.wellClick(row, col);
                                        }}
                                    />
                                    <SampleViewRound {...this.props} platerow={this.props.plate.rowTitle[row]} platecol={this.props.plate.colTitle[col]} radius={radius} />
                                </svg>
                            </div>
                            );
                        }
                        plateWells.push(cell);
                    }
                }

                return plateWells;
            }

            return (
                <div className="crystal-plate"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: `repeat(${nbcols + 1}, ${Math.floor(100 / (nbcols + 1))}%)`,
                        gridTemplateRows: `repeat(${nbrows + 1}, 1fr)`,
                        width: '100%',
                    }}
                >
                    {fillTopLeftCell()}
                    {fillFirstRowWithColLabels()}
                    {fillFirstColWithRowLabels()}
                    {getPlateWells()}

                </div >
            );
        }
    }
}
export default PlateGrid;

PlateGrid.proptypes = {
    plate: PropTypes.shape({
        /* name of the plate */
        name: PropTypes.string.isRequired,
        /* still needed */
        margin: PropTypes.number,
        /* Array which size corrseponds to the number of rows in the grid and which content corresponds to the row label. Example  ['A', 'B', 'C'] render a 3 row grid which 
        labels are 'A', 'B', 'C' */
        rowTitle: PropTypes.array.isRequired,
        /* Array which size corrseponds to the number of columns in the grid and which content corresponds to the column label. Example  ['1', '2', '3'] renders a 3 columns grid which 
        labels are '1', '2', '3' */
        colTitle: PropTypes.array.isrequired,
        /* Shape of the plate wells */
        wellShape: PropTypes.oneOf(['square', 'round', 'roundBlock']).isrequired,
        /* Optional array used to defined well size for each column. Example for a 3 col plate: wellSize= [ 25, 40, 100] defines that well size for first col is 25%, wellsize from 2nd col is 
      40% and wellSize for the last col is 100%. The percentage refers to the well location cell not to the plate. wellShape array must be the same length as colTitle. This currently only work 
      for 'roundBlock' well shape */
        wellSize: PropTypes.array,
        /* plate title */
        title: PropTypes.string
    }),
    /* selected well. Format: plateName:RowLabel:ColLabel */
    selectedWell: PropTypes.string,
    /* ??? */
    handleSelectRowSample: PropTypes.func,
    /* ??? */
    handleSelectRowBuffer: PropTypes.func,
    /* ??? */
    handleLoadPlateRowsSample: PropTypes.func,
    /* ??? */
    handleLoadPlateColumnsSample: PropTypes.func,
    /* ??? */
    handlePlateAddRowDefaultValueSample: PropTypes.func,
    /* ??? */
    handleLoadPlateRowsBuffer: PropTypes.func,
    /* ??? */
    handleLoadPlateColumnsBuffer: PropTypes.func,
    /* ??? */
    handlePlateAddRowDefaultValueBuffer: PropTypes.func,







}



// WEBPACK FOOTER //
// ./src/components/saxs/CrystalPlate/Plate.jsx